import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import MarketingSettingService from "services/crm/marketingSettingService";

export const searchHinhThuc = createAsyncThunk(
    "mktSetting/searchHinhThuc",
    async (data, { rejectWithValue }) => {
        try {
            const response = await MarketingSettingService.searchHinhThuc(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const defaultHinhThuc = createAsyncThunk(
    "mktSetting/defaultHinhThuc",
    async (isDefault, { rejectWithValue }) => {
        try {
            const response = await MarketingSettingService.getDefaultHinhThuc(isDefault);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const upSertHinhThuc = createAsyncThunk(
    "mtkSetting/upSertHinhThuc",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await MarketingSettingService.upSertHinhThuc(data);
            if (onSuccess) onSuccess();
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const deleteHinhThuc = createAsyncThunk(
    "mktSetting/deleteHinhThuc",
    async (data, { rejectWithValue }) => {
        try {
            const { id, onSuccess } = data;
            const response = await MarketingSettingService.deleteHinhThuc(id);
            if (onSuccess) onSuccess();
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const searchTrangThai = createAsyncThunk(
    "mktSetting/searchTrangThai",
    async (data, { rejectWithValue }) => {
        try {
            const response = await MarketingSettingService.searchTrangThai(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const defaultTrangThai = createAsyncThunk(
    "mktSetting/defaultTrangThai",
    async (isDefault, { rejectWithValue }) => {
        try {
            const response = await MarketingSettingService.deleteTrangThai(isDefault);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const upSertTrangThai = createAsyncThunk(
    "mtkSetting/upSertTrangThai",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await MarketingSettingService.upSertTrangThai(data);
            if (onSuccess) onSuccess();
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const deleteTrangThai = createAsyncThunk(
    "mktSetting/deleteTrangThai",
    async (data, { rejectWithValue }) => {
        try {
            const { id, onSuccess } = data;
            const response = await MarketingSettingService.deleteTrangThai(id);
            if (onSuccess) onSuccess();
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

const initialState = {
    loading: false,
    dmHinhThucList: [],
    defaultHinhThuc: [],
    dmTrangThaiList: [],
    defaultTrangThai: []
};

export const mktSettingSlice = createSlice({
    name: "mtkSetting",
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true;
        },
    },
    extraReducers: (builder) => {
        builder
            // search call history
            .addCase(searchHinhThuc.pending, (state) => {
                state.loading = true;
            })
            .addCase(searchHinhThuc.fulfilled, (state, action) => {
                state.loading = false;
                state.dmHinhThucList = action.payload;
            })
            .addCase(searchHinhThuc.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(defaultHinhThuc.pending, (state) => {
                state.loading = true;
            })
            .addCase(defaultHinhThuc.fulfilled, (state, action) => {
                state.loading = false;
                state.defaultHinhThuc = action.payload;
            })
            .addCase(defaultHinhThuc.rejected, (state, action) => {
                state.loading = false;
            })
            // search
            .addCase(upSertHinhThuc.pending, (state) => {
                state.loading = true;
            })
            .addCase(upSertHinhThuc.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(upSertHinhThuc.rejected, (state, action) => {
                state.loading = false;
            })
            // add new campaign
            .addCase(deleteHinhThuc.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteHinhThuc.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteHinhThuc.rejected, (state, action) => {
                state.loading = false;
            })

            // search call history
            .addCase(searchTrangThai.pending, (state) => {
                state.loading = true;
            })
            .addCase(searchTrangThai.fulfilled, (state, action) => {
                state.loading = false;
                state.dmTrangThaiList = action.payload;
            })
            .addCase(searchTrangThai.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(defaultTrangThai.pending, (state) => {
                state.loading = true;
            })
            .addCase(defaultTrangThai.fulfilled, (state, action) => {
                state.loading = false;
                state.defaultTrangThai = action.payload;
            })
            .addCase(defaultTrangThai.rejected, (state, action) => {
                state.loading = false;
            })
            // search
            .addCase(upSertTrangThai.pending, (state) => {
                state.loading = true;
            })
            .addCase(upSertTrangThai.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(upSertTrangThai.rejected, (state, action) => {
                state.loading = false;
            })
            // add new campaign
            .addCase(deleteTrangThai.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteTrangThai.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteTrangThai.rejected, (state, action) => {
                state.loading = false;
            })
    },
});

export const { showLoading } = mktSettingSlice.actions;

export default mktSettingSlice.reducer;
